module.exports = __webpack_public_path__ + "img/tower1.2adf2971.png";